import React from 'react';
import './Footer.css';
import cartpool from "../Icons/cartpool-logo.png"
const Footer = () => {

    return(
        <div className='box2'>
        <div>
            <img src={cartpool} alt="carticon" className='carticon'/>
        </div>
        <div className='text-box2'>
            <div className='text2-space'>CONTACT</div>
            <div className='text2'>Instagram: cartpoolhq</div>
            <div className='text2'>Email: cartpool@gmail.com</div>
        </div>
        </div>
    );
    
};

export default Footer;